import {
    SITE_DETAILS,
    SITE_DETAILS_BY_NO,
    MATERIAL_DATA,
    ASSOCIATE_MATERIAL,
    SAVE_MATERIAL,
    MATERIAL_TYPES,
    GET_REPORTEE,
    GET_WAREHOUSE,
    PENDING_MATERIAL,
    VIEW_MATERIAL,
    MATERIAL_APPROVAL,
    CREDITLIMIT_LEDGER,
    TO_EMPLOYEE, STORE_ADDRESS, ERP_INVENTORY, EMP_MRF_LISTING, EMP_MRF_MATERIAL,
    INCREASE_CREDIT_LIMIT, USER_CREDIT_LIMIT,CAT_BY_BRAND,GET_CAT, FETCH_MRF_LIST, MRF_TYPE_DROPDOWN, SHOW_MRF_VIEW, SALES_RETURN_MRF, SALES_RETURN_MRF_SHIPMENT, SEND_SALES_RETURN_TO_ERP, MRF_TYPE_LIST,
    MRF_TYPE_DROPDOWN_DATA
} from "./type";

const initalState = {
    siteDetails: [],
    siteByNo: [],
    MaterialData: [],
    BrandData: [],
    CategoryData: [],
    associateMaterial: [],
    savedMaterial: [],
    materialTypes: [],
    reportee: [],
    warehouse:[],
    pendingListing:[],
    viewMaterial:[],
    materialApproval:[],
    creditLimitLedger: [],
    toEmployee:[],
    storeAddress:[],
    erpInventory:[],
    empMrfListing:[],
    empMrfMaterial: [],
    addCreditLimit:[],
    userCreditLimit: [],
    mrfListingFinance: [],
    mrfTypeDropdown: [],
    showMrfView: [],
    getSalesReturnMrfDetails: [],
    saveSalesReturnOnErp: [],
    getSalesReturnShipments: [],
    mrfTypeData: [],
    dropdownData: [],
}

const MaterialRequistionForm = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case SITE_DETAILS:
            return {
                ...state,
                siteDetails: payload,
            };
        case SITE_DETAILS_BY_NO:
            return {
                ...state,
                siteByNo: payload,
            };
        case MATERIAL_DATA:
            return {
                ...state,
                MaterialData: payload,
            };
        case CAT_BY_BRAND: 
            return {
                ...state,
                BrandData: payload,
            };
        case GET_CAT: 
            return {
                ...state,
                CategoryData: payload,
            };
        case ASSOCIATE_MATERIAL:
            return {
                ...state,
                associateMaterial: payload,
            };
        case SAVE_MATERIAL:
            return {
                ...state,
                savedMaterial: payload,
            };
        case MATERIAL_TYPES:
            return {
                ...state,
                materialTypes: payload,
            };
        case GET_REPORTEE:
            return {
                ...state,
                reportee: payload,
            };
        case GET_WAREHOUSE:
            return {
                ...state,
                warehouse: payload,
            };
        case PENDING_MATERIAL:
            return {
                ...state,
                pendingListing: payload,
            };
        case VIEW_MATERIAL:
            return {
                ...state,
                viewMaterial: payload,
            };
        case MATERIAL_APPROVAL:
            return {
                ...state,
                materialApproval: payload,
            };
        case CREDITLIMIT_LEDGER:
            return {
                ...state,
                creditLimitLedger: payload,
            };
        case TO_EMPLOYEE:
            return {
                ...state,
                toEmployee: payload,
            };
        case STORE_ADDRESS:
            return {
                ...state,
                storeAddress: payload,
            };
        case ERP_INVENTORY:
            return {
                ...state,
                erpInventory: payload,
            };
        case EMP_MRF_LISTING:
            return {
                ...state,
                empMrfListing: payload,
            };
        case EMP_MRF_MATERIAL:
            return {
                ...state,
                empMrfMaterial: payload,
            };
        case INCREASE_CREDIT_LIMIT:
            return {
                ...state,
                addCreditLimit: payload,
            };
        case USER_CREDIT_LIMIT:
            return {
                ...state,
                userCreditLimit: payload,
            };
        case FETCH_MRF_LIST:
            return {
                ...state,
                mrfListingFinance: payload,
            };
        case MRF_TYPE_DROPDOWN:
            return {
                ...state,
                mrfTypeDropdown: payload,
            };
        case SHOW_MRF_VIEW:
            return {
                ...state,
                showMrfView: payload,
            };
        case SALES_RETURN_MRF:
            return {
                ...state,
                getSalesReturnMrfDetails: payload,
            };
        case SALES_RETURN_MRF_SHIPMENT:
            return {
                ...state,
                getSalesReturnShipments: payload,
            };
        case SEND_SALES_RETURN_TO_ERP:
            return {
                ...state,
                saveSalesReturnOnErp: payload,
            };
        case MRF_TYPE_LIST:
            return {
                ...state,
                mrfTypeData: payload,
            };
        case MRF_TYPE_DROPDOWN_DATA:
            return {
                ...state,
                dropdownData: payload,
            };
        default:
            return {
                ...state,
            };
    }
}

export default MaterialRequistionForm